import React, { useEffect, useState } from 'react';
import { Col, Row, Input, message, Spin, Space } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import moment from 'moment';

import IconPriorizar from '../../assets/icons/priorizar.svg';
import {
  getPendenteAtendimento,
  patchPriorizarAtendimento,
} from '../../services';
import { useAuth } from '../../hooks/auth';
import { formatDuration } from '../../helpers/formatarDataFila';
import * as S from './styles';

export function TableCustom({ dateRange, setHeaders, setDataCSV }) {
  const { temPermissao } = useAuth();
  const [dataTable, setDataTable] = useState([]);
  const [dataRender, setDataRender] = useState([]);
  const [columnsTable, setColumnsTable] = useState([]);
  const [inputBusca, setInputBusca] = useState('');
  const [spinning, setSpinning] = useState(false);
  const [isAdm, setIsAdm] = useState(false);

  const formatarTempoFila = (value = '') => {
    if (value.length > 16) {
      return formatDuration(value);
    }
      const time = value.replace(/(\d{2}):(\d{2}):(\d{2}).(\d+)/g, '$1:$2:$3');
      return time;
  };

  const columns = [
    {
      title: 'Priorizar',
      dataIndex: 'priorizar',
      key: 'priorizar',
      width: '10%',
      align: 'center',
      render: (_, record) => priorizar({ record }),
    },
    {
      title: 'Solicitação',
      dataIndex: 'solicitacao',
      key: 'solicitacao',
      align: 'center',
    },
    {
      title: 'Tipo',
      dataIndex: 'tipo',
      key: 'tipo',
      align: 'center',
    },
    {
      title: 'Cliente',
      dataIndex: 'cliente',
      key: 'cliente',
      align: 'center',
    },
    {
      title: 'Tempo Fila',
      dataIndex: 'fila',
      key: 'tempofila',
      align: 'center',
      render: (_, record) => formatarTempoFila(record?.fila),
    },
  ];

  const headers = [
    { label: 'Solicitação', key: 'solicitacao' },
    { label: 'Tempo Fila', key: 'tempoFila' },
    { label: 'Data do Cadastro', key: 'dataCadastroFormatada' },
  ];

  const initialData = async () => {
    const page = 1;
    const numeroRegistros = 1000;
    setHeaders(headers);
    setSpinning(true);
    try {
      const response = await getPendenteAtendimento({ page, numeroRegistros });

      const data = response.data.items.map(item => ({
          id: item?.id,
          solicitacao: item?.idIntegracao,
          tipo: item?.matriz?.nome,
          cliente: item?.cliente?.nomeFantasia,
          fila: item?.tempoFila || '00:00:00',
          dataCadastro: moment(item?.dataCadastro).format('YYYY/MM/DD'),
          dataCadastroFormatada: moment(item?.dataCadastro).format(
            'DD/MM/YYYY'
          ),
        }));
      setSpinning(false);

      if (dateRange.from && dateRange.to) {
        const startDate = dateRange.from;
        const endDate = dateRange.to;
        const fromDate = await data.map(item => (
            moment(item.dataCadastro).isBetween(startDate, endDate) && item
          ));
        return setDataTable(fromDate);
      }
        return setDataTable(data);
    } catch (error) {
      setSpinning(false);
      return message.error(
        error?.response?.detail || 'Erro ao carregar lista de Solicitações.'
      );
    }
  };

  const inputFilter = () => {
    const busca = dataTable.filter(item => {
      const concatenado = item?.solicitacao
        ?.concat(item?.cliente)
        ?.concat(item?.tipo);

      return concatenado?.toLowerCase().includes(inputBusca?.toLowerCase());
    });

    return setDataRender(busca);
  };

  const formatColumns = () => {
    const newCols = isAdm ? columns : columns.splice(1, 4);

    return setColumnsTable(newCols);
  };

  useEffect(() => {
    initialData();
    setDataCSV(dataRender);
  }, [dateRange]);

  useEffect(() => {
    formatColumns();
  }, [isAdm]);

  useEffect(() => {
    inputFilter();
  }, [inputBusca, dataTable]);

  useEffect(() => {
    const isAdmin = temPermissao(['MenuConsultasExternas']);
    setIsAdm(isAdmin);
  }, [temPermissao]);

  const handlerPriorizar = async item => {
    setSpinning(true);
    const { status } = await patchPriorizarAtendimento(item?.id);

    if (status === 200) {
      setSpinning(false);
      return initialData();
    }

    if (status !== 200) {
      setSpinning(false);
      return message.error('Erro ao priorizar solicitação, tente novamente.');
    }
  };

  const priorizar = ({ record }) => (
      <Space
        style={{ cursor: 'pointer' }}
        onClick={() => handlerPriorizar(record)}
      >
        <img src={IconPriorizar} alt="priorizar" />
      </Space>
    );
  return (
    <Col>
      <Spin
        spinning={spinning}
        size="large"
        style={{
          position: 'fixed',
          top: '25%',
        }}
        tip="Carregando..."
      >
        <S.Container>
          <Row>
            <S.ContainerFilter>
              <Input
                placeholder="Buscar"
                size="large"
                prefix={<SearchOutlined style={{}} />}
                onChange={e => setInputBusca(e.target.value)}
              />
            </S.ContainerFilter>
          </Row>
          <Row>
            <S.ContainerTable>
              <S.TableCustom
                rowKey={Math.random}
                columns={columnsTable}
                dataSource={dataRender || dataTable}
                scroll={{ y: 480 }}
                pagination={false}
              />
            </S.ContainerTable>
          </Row>
        </S.Container>
      </Spin>
    </Col>
  );
}
